package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.CampaignOutline: ImageVector
    get() {
        if (_campaignOutline != null) {
            return _campaignOutline!!
        }
        _campaignOutline = Builder(name = "CampaignOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 16.0f, viewportHeight = 16.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(12.9487f, 8.391f)
                lineTo(12.9487f, 7.141f)
                lineTo(15.9615f, 7.141f)
                lineTo(15.9615f, 8.391f)
                lineTo(12.9487f, 8.391f)
                lineTo(12.9487f, 8.391f)
                moveTo(13.9006f, 13.9999f)
                lineTo(11.4904f, 12.1923f)
                lineTo(12.25f, 11.1955f)
                lineTo(14.6602f, 13.0032f)
                lineTo(13.9006f, 13.9999f)
                lineTo(13.9006f, 13.9999f)
                moveTo(12.2179f, 4.3045f)
                lineTo(11.4583f, 3.3077f)
                lineTo(13.8686f, 1.5f)
                lineTo(14.6282f, 2.4968f)
                lineTo(12.2179f, 4.3045f)
                lineTo(12.2179f, 4.3045f)
                moveTo(2.3558f, 13.1666f)
                lineTo(2.3558f, 9.9134f)
                lineTo(1.5064f, 9.9134f)
                curveTo(1.0908f, 9.9134f, 0.7358f, 9.7662f, 0.4415f, 9.4719f)
                curveTo(0.1472f, 9.1776f, 0.0f, 8.8226f, 0.0f, 8.407f)
                lineTo(0.0f, 7.125f)
                curveTo(0.0f, 6.7094f, 0.1472f, 6.3544f, 0.4415f, 6.0601f)
                curveTo(0.7358f, 5.7657f, 1.0908f, 5.6186f, 1.5064f, 5.6186f)
                lineTo(4.7275f, 5.6186f)
                lineTo(8.4615f, 3.391f)
                lineTo(8.4615f, 12.141f)
                lineTo(4.7275f, 9.9134f)
                lineTo(3.6057f, 9.9134f)
                lineTo(3.6057f, 13.1666f)
                lineTo(2.3558f, 13.1666f)
                lineTo(2.3558f, 13.1666f)
                moveTo(7.2115f, 9.9199f)
                lineTo(7.2115f, 5.6121f)
                lineTo(5.0737f, 6.8686f)
                lineTo(1.5064f, 6.8686f)
                curveTo(1.4423f, 6.8686f, 1.3835f, 6.8953f, 1.3301f, 6.9487f)
                curveTo(1.2767f, 7.0021f, 1.25f, 7.0609f, 1.25f, 7.125f)
                lineTo(1.25f, 8.407f)
                curveTo(1.25f, 8.4711f, 1.2767f, 8.5299f, 1.3301f, 8.5833f)
                curveTo(1.3835f, 8.6367f, 1.4423f, 8.6634f, 1.5064f, 8.6634f)
                lineTo(5.0737f, 8.6634f)
                lineTo(7.2115f, 9.9199f)
                lineTo(7.2115f, 9.9199f)
                moveTo(9.6154f, 10.3653f)
                lineTo(9.6154f, 5.1666f)
                curveTo(9.9423f, 5.4626f, 10.2056f, 5.8355f, 10.4054f, 6.2852f)
                curveTo(10.6052f, 6.735f, 10.7051f, 7.2286f, 10.7051f, 7.766f)
                curveTo(10.7051f, 8.3034f, 10.6052f, 8.797f, 10.4054f, 9.2468f)
                curveTo(10.2056f, 9.6965f, 9.9423f, 10.0694f, 9.6154f, 10.3653f)
                lineTo(9.6154f, 10.3653f)
                moveTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
                lineTo(4.2307f, 7.766f)
            }
        }
        .build()
        return _campaignOutline!!
    }

private var _campaignOutline: ImageVector? = null
